module.exports = __webpack_public_path__ + "static/img/default_pic.35c6ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default_pic.png
// module id = AknM
// module chunks = 1